import { createRouter, createWebHistory } from 'vue-router'

import { basicRoutes } from './basic'

const modules = import.meta.glob('./modules/*/*.js', { eager: true })
const userRouteModuleList = []

// 加入到路由集合中
Object.keys(modules).forEach(function (key) {
  const mod = modules[key].default || {}
  const modList = Array.isArray(mod) ? [].concat(mod) : [mod]
  userRouteModuleList.push(...modList)
})

// 兼容无sort字段的路由
userRouteModuleList.sort((a, b) => (Number.isFinite(a.sort) ? a.sort : 999) - (Number.isFinite(b.sort) ? b.sort : 999))

export const asyncUserRoutes = [...userRouteModuleList]
export const baseRoutes = [...basicRoutes]

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [...asyncUserRoutes, ...baseRoutes],
  strict: true,
  scrollBehavior: () => ({ left: 0, top: 0 })
})

export default router
